import React from 'react'
import {
  Grid,
  Col,
  Row,
  ButtonToolbar,
  ToggleButtonGroup,
  ToggleButton,
} from 'react-bootstrap'
import {
  CFXProFormatNumber,
  CalculatorCol,
  FormattedDate,
} from '../../helpers/formatting'
import {connect} from 'react-redux'
import {defaultNumbersFor} from '../../helpers/defaultNumbers'
import {HEIFER_INDEX, STEER_INDEX, REGEX} from '../../constants'
import {
  daysOnFeed,
  backgrounderSaleWeight,
  backgrounderExpectedSellingPrice,
  backgrounderTotalCost,
  backgrounderTotalRevenue,
  backgrounderProfitPerHeader,
  backgrounderFinishDate,
} from '../../helpers/calculators/backgrounderCalculations'
import {feedValuesClosestToDate} from '../../helpers/calculators/sharedCalculations'
import {
  saveBackgrounder,
  updateBackgrounder,
  replaceAllDefaults,
} from '../../actions'
import {withRouter} from 'react-router'
import CFXProReactCollapsible from '../cfxProReactCollapsible'
import {buildLastUpdateFooter} from '../../helpers/textbuilders'
import {parseApiStringDateToDate} from '../../helpers/feedParser'
import {updateDefaultNumbers} from '../../reducers'
import * as at from '../../actionTypes'
import api from '../../api'
import {SyncableButton} from '../../helpers/button'
import {syncDefaultNumbers, syncUserData} from '../../helpers/syncing'
import _ from 'lodash'
import moment from 'moment'

var backgrounderSavedDefaultsTimeout

@withRouter
@connect((state) => {
  const {
    app: {isLoggedIn},
    userData: {userId, backgrounders},
    data: {dtn, basis},
    defaultNumbers,
  } = state

  return {
    isLoggedIn,
    userId,
    backgrounders,
    defaultNumbers,
    dtnFeedData: dtn,
    basisValues: basis,
  }
})
@api
class BackgrounderCalculator extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      type: 0,
      purchaseWeight: '',
      purchaseDate: '',
      purchasePricePerLb: '',
      avgDailyGain: '',
      costOfGain: '',
      saleDate: '',
      isActive: true,
      syncingBackgrounder: false,
      syncingDefaults: false,
      didSaveDefaults: false,
      // Deep Copy the object in full
      localDefaultNumbers: JSON.parse(
        JSON.stringify(this.props.defaultNumbers),
      ),
    }
  }

  componentWillMount() {
    const {
      match: {
        params: {id = null},
      },
      backgrounders,
    } = this.props

    if (id && backgrounders[id]) {
      const {
        type,
        purchaseWeight,
        purchaseDate,
        purchasePricePerLb,
        avgDailyGain,
        costOfGain,
        saleDate,
      } = backgrounders[id]
      this.setState({
        type,
        purchaseWeight,
        purchaseDate,
        purchasePricePerLb,
        avgDailyGain,
        costOfGain,
        saleDate,
      })
    }
  }

  onValueChanged = (id, value, sender = null) => {
    if (_.includes(id, 'Date')) {
      value = FormattedDate(value)
    }
    if (id in this.state) {
      this.setState({[id]: value})
    } else {
      if (sender != null && !sender.target.validity.valid) {
        return
      }

      const {localDefaultNumbers} = this.state
      const newDefaultNumbers = updateDefaultNumbers(localDefaultNumbers, {
        type: at.BACKGROUNDER_UPDATE_DEFAULT_NUMBER,
        payload: {
          data: {key: id, value},
        },
      })

      this.setState({localDefaultNumbers: newDefaultNumbers})
    }
  }

  calculate(backgrounder) {
    const {localDefaultNumbers} = this.state
    const {dtnFeedData, basisValues} = this.props

    if (
      !this.isFilledBackgrounder(backgrounder) ||
      dtnFeedData == null ||
      basisValues == null ||
      localDefaultNumbers == null
    ) {
      return {
        daysOnFeed: '',
        saleWeight: '',
        expectedSelling: '',
        totalCost: 0,
        totalRevenue: '',
        profitPerHead: '',
      }
    }

    const saleWeight = backgrounderSaleWeight(backgrounder)

    const defaults = defaultNumbersFor(
      localDefaultNumbers,
      'backgrounder',
      backgrounder.type === HEIFER_INDEX ? 'heifer' : 'steer',
      saleWeight,
    )

    return {
      daysOnFeed: daysOnFeed(backgrounder),
      saleWeight: saleWeight,
      expectedSelling: backgrounderExpectedSellingPrice(
        defaults,
        backgrounder,
        dtnFeedData,
        basisValues,
      ),
      totalCost: backgrounderTotalCost(defaults, backgrounder),
      totalRevenue: backgrounderTotalRevenue(
        defaults,
        backgrounder,
        dtnFeedData,
        basisValues,
      ),
      profitPerHead: backgrounderProfitPerHeader(
        defaults,
        backgrounder,
        dtnFeedData,
        basisValues,
      ),
    }
  }

  localSaveBackgrounder() {
    const backgrounder = this.state
    if (!this.isFilledBackgrounder(backgrounder)) {
      alert('Please fill out all fields!')
      return
    }

    const {
      isLoggedIn,
      userId,
      backgrounders,
      apiInstance,
      dispatch,
      history,
      match: {
        params: {id = null},
      },
    } = this.props

    const calcValues = this.calculate(backgrounder)

    const fullBackgrounder = {
      id: id === null ? this.nextId(backgrounders) : id,
      ...backgrounder,
      ...calcValues,
    }

    // Temp value to ensure we don't sync the defaults unless the user saves them
    delete fullBackgrounder['syncingBackgrounder']
    delete fullBackgrounder['syncingDefaults']
    delete fullBackgrounder['didSaveDefaults']
    delete fullBackgrounder['localDefaultNumbers']

    if (isLoggedIn) {
      fullBackgrounder.userId = userId
      this.setState({syncingBackgrounder: true})
      syncUserData(apiInstance, fullBackgrounder, dispatch, 'Backgrounder')
        .then((response) => {
          this.setState({syncingBackgrounder: false})
          history.push('/breakeven/backgrounder')
        })
        .catch((err) => {
          this.setState({syncingBackgrounder: false})
        })
    } else {
      this.updateReduxWithBackgrounder(fullBackgrounder)
    }
  }

  updateReduxWithBackgrounder(fullBackgrounder) {
    const {
      dispatch,
      history,
      match: {
        params: {id = null},
      },
    } = this.props

    if (id === null) {
      dispatch(saveBackgrounder(fullBackgrounder))
    } else {
      dispatch(updateBackgrounder(fullBackgrounder))
    }
    history.push('/breakeven/backgrounder')
  }

  localSaveDefaults = () => {
    const {localDefaultNumbers} = this.state
    const {isLoggedIn, apiInstance, userId} = this.props

    if (isLoggedIn) {
      localDefaultNumbers.userId = userId
      this.setState({syncingDefaults: true})
      syncDefaultNumbers(apiInstance, localDefaultNumbers)
        .then((response) => {
          this.updateReduxWithDefaults(localDefaultNumbers)
          this.setState({syncingDefaults: false})
        })
        .catch(() => {
          this.setState({syncingDefaults: false})
        })
    } else {
      this.updateReduxWithDefaults(localDefaultNumbers)
    }
  }

  updateReduxWithDefaults = () => {
    const {localDefaultNumbers} = this.state
    const {dispatch} = this.props
    dispatch(replaceAllDefaults(localDefaultNumbers))
    this.setState({didSaveDefaults: true})
    clearTimeout(backgrounderSavedDefaultsTimeout)
    backgrounderSavedDefaultsTimeout = setTimeout(() => {
      this.setState({didSaveDefaults: false})
    }, 2000)
  }

  nextId(backgrounders) {
    const backgrounderIds = Object.keys(backgrounders)

    var lowestBackgrounderId = -1
    if (backgrounderIds.length > 0) {
      lowestBackgrounderId = Math.min(...backgrounderIds)

      if (lowestBackgrounderId == null || lowestBackgrounderId > 0) {
        lowestBackgrounderId = -1
      } else {
        lowestBackgrounderId -= 1
      }
    }
    return lowestBackgrounderId
  }

  isFilledBackgrounder(backgrounder) {
    let saleDate = moment(backgrounder.saleDate, 'YYYY-MM-DD', true)
    let purchaseDate = moment(backgrounder.purchaseDate, 'YYYY-MM-DD', true)

    console.log('saleDate', saleDate)
    console.log('purchaseDate', purchaseDate)
    console.log(
      'saleDate.isAfter(purchaseDate)',
      saleDate.isAfter(purchaseDate),
    )

    return (
      backgrounder.purchaseWeight !== null &&
      backgrounder.purchaseWeight !== '' &&
      backgrounder.purchaseDate !== null &&
      backgrounder.purchaseDate !== '' &&
      !_.isNil(purchaseDate) &&
      backgrounder.purchasePricePerLb !== null &&
      backgrounder.purchasePricePerLb !== '' &&
      backgrounder.avgDailyGain !== null &&
      backgrounder.avgDailyGain !== '' &&
      backgrounder.costOfGain !== null &&
      backgrounder.costOfGain !== '' &&
      backgrounder.saleDate !== null &&
      backgrounder.saleDate !== '' &&
      !_.isNil(saleDate) &&
      saleDate.isAfter(purchaseDate)
    )
  }

  render() {
    const backgrounder = Object.assign({}, this.state)

    const {
      match: {
        params: {id = null},
      },
      dtnFeedData,
      basisValues,
    } = this.props
    const {
      localDefaultNumbers,
      didSaveDefaults,
      syncingDefaults,
      syncingBackgrounder,
    } = this.state

    const defaults = defaultNumbersFor(
      localDefaultNumbers,
      'backgrounder',
      backgrounder.type === HEIFER_INDEX ? 'heifer' : 'steer',
      backgrounderSaleWeight(backgrounder),
    )

    const {
      daysOnFeed,
      saleWeight,
      expectedSelling,
      totalCost,
      totalRevenue,
      profitPerHead,
    } = this.calculate(backgrounder)

    const finishDate = backgrounderFinishDate(defaults, backgrounder)

    const {liveCattle, cdn} = feedValuesClosestToDate(
      finishDate,
      dtnFeedData,
      basisValues,
    )

    return (
      <div className="cfx-backgrounder-calculator">
        <Grid>
          <h1 className="text-center">Backgrounder</h1>
          <BackgrounderInput
            type={backgrounder.type}
            purchaseWeight={backgrounder.purchaseWeight}
            purchaseDate={backgrounder.purchaseDate}
            purchasePricePerLb={backgrounder.purchasePricePerLb}
            avgDailyGain={backgrounder.avgDailyGain}
            costOfGain={backgrounder.costOfGain}
            saleDate={backgrounder.saleDate}
            onValueChanged={this.onValueChanged}
          />
          <CFXProReactCollapsible title="Default Numbers">
            <BackgrounderDefaultNumbers
              barleyCost={defaults.barleyCost}
              syncingDefaults={syncingDefaults}
              didSaveDefaults={didSaveDefaults}
              saveDefaults={this.localSaveDefaults}
              onValueChanged={this.onValueChanged}
            />
          </CFXProReactCollapsible>
          <CFXProReactCollapsible title="Results" open={true}>
            <BackgrounderResults
              daysOnFeed={daysOnFeed}
              saleWeight={saleWeight}
              expectedSelling={expectedSelling}
              totalCost={totalCost}
              totalRevenue={totalRevenue}
              profitPerHead={profitPerHead}
            />
          </CFXProReactCollapsible>
          <Row>
            <SyncableButton
              className="cfxpro__btn-default btn btn-default"
              style={{width: '75%', display: 'block', margin: '1em auto'}}
              isSyncing={syncingBackgrounder}
              isUpdate={id != null}
              baseTitle="Backgrounder"
              onClick={() => this.localSaveBackgrounder()}
            />
          </Row>
          <Row>
            <div className="cfx-rt-table">
              <div className="cfx-rt-footer">
                {buildLastUpdateFooter(
                  'LC Futures price is as of (date) at (time)',
                  liveCattle == null
                    ? null
                    : parseApiStringDateToDate(liveCattle.lastUpdated),
                )}
                <br />
                {buildLastUpdateFooter(
                  'CDT and CDN $ is as of (date) at (time)',
                  cdn == null
                    ? null
                    : parseApiStringDateToDate(cdn.lastUpdated),
                )}
              </div>
            </div>
          </Row>
        </Grid>
      </div>
    )
  }
}

export default BackgrounderCalculator

class BackgrounderInput extends React.Component {
  render() {
    const {
      type,
      purchaseWeight,
      purchaseDate,
      purchasePricePerLb,
      avgDailyGain,
      costOfGain,
      saleDate,
      onValueChanged,
    } = this.props

    const saleDateIsBeforePurchaseDate = moment(
      saleDate,
      'YYYY-MM-DD',
    ).isBefore(moment(purchaseDate, 'YYYY-MM-DD'))

    // Fixes issue with bootstrap pushing the fields around when the message for purchase and sale date show
    var purchaseDateClass = ''
    if (saleDateIsBeforePurchaseDate) {
      purchaseDateClass = 'bootstrap-message-margin-purchase-weight'
    }

    var purchasePricePerLbClass = ''
    if (saleDateIsBeforePurchaseDate) {
      purchasePricePerLbClass = 'bootstrap-message-margin-purchase-price-per-lb'
    }

    return (
      <div>
        <Row>
          <Col>
            <ButtonToolbar>
              <ToggleButtonGroup
                id="type"
                type="radio"
                name="options"
                value={type}
                onChange={(e) => onValueChanged('type', e)}
              >
                <ToggleButton value={HEIFER_INDEX}>
                  {type === HEIFER_INDEX && (
                    <i style={{paddingRight: '10px'}} className="fa fa-check" />
                  )}Heifer
                </ToggleButton>
                <ToggleButton value={STEER_INDEX}>
                  {type === STEER_INDEX && (
                    <i style={{paddingRight: '10px'}} className="fa fa-check" />
                  )}Steer
                </ToggleButton>
              </ToggleButtonGroup>
            </ButtonToolbar>
          </Col>
        </Row>
        <Row style={{padding: '10px 0'}}>
          <CalculatorCol
            id="purchaseWeight"
            type="number"
            label="Purchase Weight"
            placeholder="lbs"
            value={purchaseWeight}
            className={purchaseDateClass}
            onChange={(e) => onValueChanged('purchaseWeight', e.target.value)}
          />
          <CalculatorCol
            id="purchaseDate"
            type="date"
            label="Purchase Date"
            placeholder="yyyy-mm-dd"
            value={purchaseDate}
            min="1970-01-01"
            max={saleDate != null ? saleDate : '9999-12-31'}
            onChange={(e) => onValueChanged('purchaseDate', e.target.value)}
            help={
              saleDateIsBeforePurchaseDate
                ? 'Purchase Date must be before Sale Date'
                : null
            }
          />
          <CalculatorCol
            id="purchasePricePerLb"
            type="number"
            label="Purchase Price Per lb"
            placeholder="$"
            value={purchasePricePerLb}
            className={purchasePricePerLbClass}
            onChange={(e) =>
              onValueChanged('purchasePricePerLb', e.target.value)
            }
          />
          <CalculatorCol
            id="avgDailyGain"
            type="number"
            label="Average Daily Gain"
            placeholder="lbs"
            value={avgDailyGain}
            onChange={(e) => onValueChanged('avgDailyGain', e.target.value)}
          />
          <CalculatorCol
            id="costOfGain"
            type="number"
            label="Cost of Gain $/lb"
            placeholder="$"
            value={costOfGain}
            onChange={(e) => onValueChanged('costOfGain', e.target.value)}
          />
          <CalculatorCol
            id="saleDate"
            type="date"
            label="Sale Date"
            placeholder="yyyy-mm-dd"
            value={saleDate}
            min={purchaseDate != null ? purchaseDate : '9999-12-31'}
            max="9999-12-31"
            onChange={(e) => onValueChanged('saleDate', e.target.value)}
            help={
              saleDateIsBeforePurchaseDate
                ? 'Sale Date must be after Purchase Date'
                : null
            }
          />
        </Row>
      </div>
    )
  }
}

class BackgrounderDefaultNumbers extends React.Component {
  render() {
    const {
      barleyCost,
      syncingDefaults,
      didSaveDefaults,
      saveDefaults,
      onValueChanged,
    } = this.props

    return (
      <div>
        <Row style={{padding: '10px 0'}}>
          <CalculatorCol
            id="barleyCost"
            type="text"
            label="Barley Cost $/Tonne"
            value={barleyCost}
            style={{margin: '0 auto'}}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('barleyCost', e.target.value, e)}
          />
        </Row>
        <Row>
          <SyncableButton
            className="cfxpro__btn-default btn btn-default"
            style={{width: '75%', display: 'block', margin: '1em auto'}}
            isSyncing={syncingDefaults}
            didSync={didSaveDefaults}
            baseTitle="Default Numbers"
            onClick={(e) => saveDefaults()}
          />
        </Row>
      </div>
    )
  }
}

class BackgrounderResults extends React.Component {
  render() {
    const {
      daysOnFeed,
      saleWeight,
      expectedSelling,
      totalCost = 0,
      totalRevenue,
      profitPerHead,
    } = this.props

    return (
      <Row style={{padding: '10px 0'}}>
        <CalculatorCol
          id="daysOnFeed"
          type="text"
          label="Days on Feed"
          value={CFXProFormatNumber(daysOnFeed, 0)}
          disabled={true}
        />
        <CalculatorCol
          id="saleWeight"
          type="text"
          label="Sale Weight"
          value={CFXProFormatNumber(saleWeight)}
          disabled={true}
        />
        <CalculatorCol
          id="expectedSelling"
          type="text"
          label="Expected Selling"
          value={CFXProFormatNumber(expectedSelling)}
          disabled={true}
        />
        <CalculatorCol
          id="totalCost"
          type="text"
          label="Total Cost"
          value={CFXProFormatNumber(totalCost)}
          disabled={true}
        />
        <CalculatorCol
          id="totalRevenue"
          type="text"
          label="Total Revenue"
          value={CFXProFormatNumber(totalRevenue)}
          disabled={true}
        />
        <CalculatorCol
          id="profitPerHead"
          type="text"
          label="Profit per Head"
          value={CFXProFormatNumber(profitPerHead)}
          disabled={true}
        />
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/breakeven/backgrounderCalculator.js